var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-container"},[_c('div',{staticClass:"admin-linkbar"},_vm._l((_vm.linkList),function(link){return _c('a',{key:link.url,attrs:{"href":link.url}},[_vm._v(_vm._s(link.displayText))])}),0),_c('div',{staticClass:"admin-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }